module.exports = __webpack_public_path__ + "img/top_popularity-one.e76c0397.png";